import React, { FC, useMemo } from "react";
import stl from "./Links.module.scss";
import cn from "classnames";
import { useTranslation } from "react-i18next";
import { useStore } from "effector-react";
import { SettingsEndpoint } from "../../store/endpoints";
import { AppConfig } from "../../config";

interface Props {
  vertical?: boolean;
}
const Links: FC<Props> = ({ vertical }) => {
  const { t } = useTranslation(AppConfig.translationFileNames.base);
  const { data: settings } = useStore(SettingsEndpoint.store);

  const links = useMemo<{ title: string; url: string }[]>(() => {
    const res = [];

    if (settings?.terms_and_conditions_url) {
      res.push({
        title: t("termsConditions"),
        url: settings.terms_and_conditions_url,
      });
    }
    if (settings?.privacy_policy_url) {
      res.push({
        title: t("privacyPolicy"),
        url: settings.privacy_policy_url,
      });
    }
    if (settings?.proclaimer_url) {
      res.push({
        title: t("proclaimer"),
        url: settings.proclaimer_url,
      });
    }

    return res;
  }, [t, settings]);

  return (
    <ul className={cn(stl.links, { [stl.vertical]: vertical })}>
      {links.map(({ title, url }) => (
        <li key={title + url} className={stl.link}>
          <a href={url} target={"_blank"} rel={"noreferrer"}>
            {title}
          </a>
        </li>
      ))}
    </ul>
  );
};

export default Links;
